/* eslint-disable @typescript-eslint/no-unused-expressions */
import Event from "../utils/events";
import axios from "axios";
import { toast } from "react-toastify";
import SecureLS from "secure-ls";
import { handleGetTokenSensedia } from "../utils/utils";

export const baseURL = process.env.REACT_APP_API_HOST || "";

const api = axios.create({
    baseURL,
});

// resquest interceptor
api.interceptors.request.use(async (request) => {
    var secStorage = new SecureLS({ encodingType: "aes" });

    // get token sensedia in storage
    let tokenSensediaStorage = secStorage.get("access_token");
    let sensediaExpiration = secStorage.get("expiration_sensedia");
    let tokenSensedia: any;

    if (!tokenSensediaStorage || sensediaExpiration < new Date()) {
        tokenSensedia = await handleGetTokenSensedia();

        const clientIDSensedia = process.env.REACT_APP_API_SENSEDIA_CLIENTID ?? "";

        if (tokenSensedia && clientIDSensedia) {
            api.defaults.headers.common["access_token"] = tokenSensedia;
            api.defaults.headers.common["client_id"] = clientIDSensedia;
        }
    }

    return request;
});

// Add a response interceptor
api.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (error.response?.status && error.response.status === 401) {
            toast.error("Sessão Expirada. Faça login novamente.");
            Event.emit("logout", "Você não esta conectado em nossos servidores");
            return error;
        }

        if (error.response?.status && error.response.status === 400 && error.response.data) {
            if (error.response.data && error.response.data.errors) {
                for (var item in error.response.data.errors) {
                    toast.error(error.response.data.errors[item].toString());
                }
            } else {
                for (var y in error.response.data) {
                    toast.error(error.response.data[y].toString());
                }
            }
        }
    }
);
export default api;
